<template>
    <div class="light-tip-mask" @click="cancel">
        <div class="light-tip-dialog" @click="e => e.stopPropagation()">
            <component ref="comp" v-bind:is="{ render: message }"></component>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.light-tip-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3020;
    @include flex-center;
}

.light-tip-dialog {
    flex-shrink: 0;
    flex-grow: 0;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #ffffff;
    padding: 5px 15px 5px 15px;
    z-index: 3001;
}
</style>

<script>
export default {
    props: {
        message: Function
    },
    methods: {
        cancel() {
            this.remove()
        }
    },
    mounted() {
        setTimeout(() => {
            this.cancel()
        }, 3000)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/info/LightTip.vue